// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionDashboardHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');
  const { isNil } = require('lodash/fp');

  var PermissionDashboardHeader = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.dashboards = this.props.permission.dashboards;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var permission = this.props.permission;
      var tenantDetail = this.props.permissionStore.tenantDetail;
      var localization = this.props.localization;
      var isTemplatePermissions = this.props.isTemplatePermissions;

      return (
        <GridLayout className='izenda-GridLayout-Custom'>
          {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.dashboards.canCreateNewDashboard)) && (
            <GridLayout.Row className='u_paddingTop u_paddingBottom'>
              <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                {localization.getText('PERMISSION_LABEL_CAN_CREATE_DASHBOARD')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(this.dashboards.canCreateNewDashboard.value)}
                    onChange={notifyChange(
                      permission.updateData.bind(permission, this.dashboards.canCreateNewDashboard, 'value'),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </div>
              </GridLayout.Col>
              {permission.isTenantSetup && (
                <GridLayout.Col cols={1} className='u_textCenter'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(this.dashboards.canCreateNewDashboard.tenantAccess)}
                    onChange={notifyChange(
                      permission.updateTenantAccess.bind(
                        permission,
                        this.dashboards,
                        this.dashboards.canCreateNewDashboard
                      ),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          )}
          {!permission.isTenantSetup && (
            <GridLayout.Row className='u_paddingTop u_paddingBottom'>
              <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                {localization.getText('PERMISSION_LABEL_DISPLAY_TILE_HEADER_IN_UNEDITABLE_DASHBOARD')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(this.dashboards.displayDashboardTileHeader.value)}
                    onChange={notifyChange(
                      permission.updateData.bind(permission, this.dashboards.displayDashboardTileHeader, 'value'),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </div>
              </GridLayout.Col>
            </GridLayout.Row>
          )}
          {(isNil(tenantDetail) ||
            this.props.checkShowGroupCommon(tenantDetail.dashboards.dashboardCategoriesSubcategories)) && (
            <GridLayout.Row className='u_paddingTop u_paddingBottom'>
              <GridLayout.Col className='izenda-PermissionCategory-SubCategory'>
                {localization.getText('PERMISSION_LABEL_DASHBOARD_CATEGORIES_SUBCATEGORIES')}
              </GridLayout.Col>
            </GridLayout.Row>
          )}
          {(isNil(tenantDetail) ||
            this.props.checkShowGroupCommon(
              tenantDetail.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory
            )) && (
            <GridLayout.Row className='u_paddingTop u_paddingBottom'>
              <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubSubCategory'>
                {localization.getText('PERMISSION_LABEL_CAN_CREATE_CATEGORY')}
              </GridLayout.Col>
              <GridLayout.Col cols={9}>
                <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(
                      this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.value
                    )}
                    onChange={notifyChange(
                      permission.updateData.bind(
                        permission,
                        this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory,
                        'value'
                      ),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </div>
              </GridLayout.Col>
              {permission.isTenantSetup && (
                <GridLayout.Col cols={1} className='u_textCenter'>
                  <Input
                    type='checkbox'
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    checked={this.props.getCheckedCommon(
                      this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory.tenantAccess
                    )}
                    onChange={notifyChange(
                      permission.updateTenantAccess.bind(
                        permission,
                        this.dashboards,
                        this.dashboards.dashboardCategoriesSubcategories.canCreateNewCategory
                      ),
                      EventsUtils.CHECKBOX
                    )}
                  />
                </GridLayout.Col>
              )}
            </GridLayout.Row>
          )}
        </GridLayout>
      );
    }
  });

  module.exports = connect()(PermissionDashboardHeader);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionDashboardHeader.jsx